import type { ComponentProps } from "react";

import { Text } from "@/shared/ui/common";
import { SmartphoneIcon } from "@/shared/ui/icons";
import { Input } from "./";

type PhoneInputProps = Omit<
  ComponentProps<typeof Input.Root>,
  "maxLength" | "type" | "placeholder"
>;

export const PhoneInput = ({ ...props }: PhoneInputProps) => {
  return (
    <Input.Root
      type="tel"
      placeholder="(555) 000-0000"
      maxLength={10}
      {...props}
    >
      <Input.Slot>
        <SmartphoneIcon />

        <Text color="dark-neutral">+1</Text>
      </Input.Slot>
    </Input.Root>
  );
};
